import { render, staticRenderFns } from "./AccessModal.vue?vue&type=template&id=282969ea&scoped=true&"
import script from "./AccessModal.vue?vue&type=script&lang=js&"
export * from "./AccessModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessModal.vue?vue&type=style&index=0&id=282969ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282969ea",
  null
  
)

export default component.exports